import './SearchHeader.css';

import { Col, Row, Select, Tabs } from 'antd';
import * as React from 'react';

import { DataSearch, ReactiveComponent } from '@appbaseio/reactivesearch';

import { collectionsMapping, searchableAttributes } from '../../mappings';
import AttributeType from './attributes/AttributeType';
import { SearchProps } from './SearchProps';
import { LotSearch } from './LotSearch';
import LotSearchReloadButton from '../LotSearchReloadButton';

const { TabPane } = Tabs;
const Option = Select.Option;
const searchFields = [
  'areaName',
  'bookAndNumber',
  'countyName',
  'countyName.keyword',
  'crownPlanNumber',
  'deedNumber.keyword',
  'deedReceiptNumber',
  'dpNumber.keyword',
  'environsName',
  'estateName',
  'imageName',
  'imageName.keyword',
  'index',
  'indexMap',
  'indexNumber',
  'location',
  'mapNumber',
  'mapReference',
  'notes',
  'parishName',
  'parishName.keyword',
  'pastoralName',
  'pastoralRunNumber',
  'plan',
  'planNumber',
  'planType',
  'primaryApplicationNumber',
  'serialAndPageNumber',
  'serialNumber',
  'serialNumberAndAlpha',
  'stateRecordReference',
  'townName',
  'townName.keyword',
  'volFol',
  'yearAndPageNumber',
  'yearAndSerialNumber',
  'sheetType',
  'sheetType.keyword',
  'districtOfficeName',
  'districtOfficeName.keyword',
  'surnameInitial',
  'dateRange',
  'miscellaneousRecord'
];

const fieldWeights = [2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,5,2,2];
const highlightFields = [
  'areaName',
  'bookAndNumber',
  'countyName',
  'crownPlanNumber',
  'deedNumber',
  'deedReceiptNumber',
  'dpNumber',
  'environsName',
  'estateName',
  'index',
  'indexMap',
  'indexNumber',
  'location',
  'mapNumber',
  'mapReference',
  'notes',
  'parishName',
  'pastoralName',
  'pastoralRunNumber',
  'plan',
  'planNumber',
  'planType',
  'primaryApplicationNumber',
  'serialAndPageNumber',
  'serialNumber',
  'serialNumberAndAlpha',
  'stateRecordReference',
  'surnameInitial',
  'townName',
  'volFol',
  'yearAndPageNumber',
  'yearAndSerialNumber',
  'sheetType',
  'sheetType',
  'districtOfficeName',
  'dateRange',
  'miscellaneousRecord'
];

export class SearchHeader extends React.Component<SearchProps, any> {
  constructor(props: SearchProps) {
    super(props);
    this.state = {
      selectedAttribute: '',
      showReloadBtn: false
    };
  }

  render() {
    return (
      <Col>
        <Row id="search-wrapper" justify="start" align="middle">
          <Col span={24} style={{ paddingTop: 20 }}>

            <Row>
              <Tabs tabPosition="left" size="small" style={{ height: 180, verticalAlign: 'middle' }}>

                <TabPane tab="Attribute" key="1">
                  <Row>
                    <Col>
                      <h3>Attribute Search</h3>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={8}>
                      <Select
                        showSearch
                        size={'large'}
                        style={{ width: '100%' }}
                        placeholder="Search By"
                        onChange={this.handleAttributeChange}
                        className={'attributeDropdown'}
                        id="attributeSearchSelect"
                      >
                        {
                          this.getSearchableAttributes().map((attr: any) => (
                            <Option key={attr.DISPLAY_NAME}>
                              {attr.DISPLAY_NAME}
                            </Option>
                          ))
                        }
                      </Select>
                    </Col>
                    <Col span={1}/>
                    {this.renderAttributeFields()}
                  </Row>
                  { this.state.showReloadBtn ? <LotSearchReloadButton /> : null }
                </TabPane>
                <TabPane tab="Keyword" key="2">
                  <Row>
                    <Col>
                      <h3>Keyword Search</h3>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <DataSearch
                        showIcon={true}
                        iconPosition={'right'}
                        themePreset={'dark'}
                        className={'searchBar'}
                        autosuggest={false}
                        componentId="keywordSearch"
                        debounce={1000}
                        URLParams={this.props.useUrlParams}
                        dataField={searchFields}
                        fieldWeights={fieldWeights}
                        highlight={true}
                        highlightField={highlightFields}
                        onValueChange={this.props.onShowHideHomePage}
                        queryFormat={'and'}
                        filterLabel='Keyword'
                      />
                    </Col>
                  </Row>
                  { this.state.showReloadBtn ? <LotSearchReloadButton /> : null }
                </TabPane>
                <TabPane tab="Lot (Ref Maps)" key="3">
                  <Row>
                    <Col>
                      <h3>Lot Search</h3>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <ReactiveComponent
                        componentId="lotSearch"
                        render={(props) => (
                          <LotSearch
                            setQuery={props.setQuery}
                            onShowHideHomePage={this.props.onShowHideHomePage}
                            showReloadButton={this.showReloadButton}
                          />
                        )}
                      />
                    </Col>
                  </Row>
                  { this.state.showReloadBtn ? <LotSearchReloadButton /> : null }
                </TabPane>
              </Tabs>
            </Row>
          </Col>
        </Row>
      </Col>
    );
  }

  showReloadButton = () => {
    this.setState({
      showReloadBtn: true
    })
  };

  handleAttributeChange = (value: any) => {
    this.setState({
      selectedAttribute: value
    });

    this.props.onShowHideHomePage(value);
  };

  getAttributeFields = (attribute: string): any => {
    return this.getSearchableAttributes().find(key => key['DISPLAY_NAME'] == attribute);
  }

  getSearchableAttributes = () => {
    let availableAttributeIds: Array<string | number> = [];
    const availableAttributes: object[] = [];
    const collectionFilterValues = this.props.collectionFilterValues;
    const restrictedCollectionIds = this.props.restrictedCollectionIds;

    // if c != null : find the attributes of selected collections
    if (collectionFilterValues && collectionFilterValues.length > 0) {
      availableAttributeIds = Array.from(this.getAttributeIds(collectionFilterValues));
    }

    // if c == null and r == '': all searchableAttributes
    if ((collectionFilterValues == null || collectionFilterValues.length == 0) && restrictedCollectionIds.length == 0) {
      availableAttributeIds = Object.keys(searchableAttributes);
    }

    // if c == null and r != '': all searchableAttributes from available collections
    if ((collectionFilterValues == null || collectionFilterValues.length == 0) && restrictedCollectionIds.length > 0) {
      const availableCollectionIds = new Set(Object.keys(collectionsMapping));
      restrictedCollectionIds.forEach(id => availableCollectionIds.delete(id));
      availableAttributeIds = Array.from(this.getAttributeIds(Array.from(availableCollectionIds)));
    }

    availableAttributeIds.forEach(attributeId => {
      availableAttributes.push(searchableAttributes[attributeId])
    });

    return availableAttributes.sort(
      (attributeA: any, attributeB: any) => (attributeA.DISPLAY_NAME > attributeB.DISPLAY_NAME) ? 1 : -1
    );
  }

  getAttributeIds(collectionIds: string[]): Set<any> {

    let attributesSet = new Set();
    Object.keys(collectionsMapping).forEach(collectionId => {
      if (collectionIds.indexOf(collectionId) > -1) {
        if (collectionsMapping[collectionId].ATTRIBUTES.length > 0) {
          attributesSet = new Set([...collectionsMapping[collectionId].ATTRIBUTES, ...Array.from(attributesSet)]);
        }
      }
    });
    return attributesSet
  }

  renderAttributeFields(): any {
    if (this.state.selectedAttribute == '') {
      return <div/>;
    }

    const attributeFields = this.getAttributeFields(
      this.state.selectedAttribute
    );

    if (attributeFields) {
      return (
        <AttributeType
          data={this.getAttributeFields(this.state.selectedAttribute)}
        />
      );
    } else {
      return (
        <Col span={15}>
          {' '}
          attribute is not available in selected collection.{' '}
          <div>
            Please choose another attribute or clear selected collection.
          </div>
        </Col>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/search/SearchHeader.tsx